import { EventReportFilter } from '@contexts/event-report/event-report-context.type';
import { EventSalesValues, LinearGraphGroupBy } from '@domain/event-report';
import { useGenericQuery } from '@hooks/use-generic-query';
import { paramsSerializer } from '@utils/format-params';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants';

interface Offer {
  soldItems: EventSalesValues;
  revenue: EventSalesValues;
}

interface Offers {
  guestlist: Offer;
  ticket: Offer;
  bottleservice: Offer;
  invitation: Offer;
  season_pass: Offer;
  checkin: Offer;
}

export interface EventSalesStatsGroupByResponse {
  [date: string]: {
    offers: Offers;
  };
}

export interface EventSalesStatsGroupByQueryParams extends EventReportFilter {
  groupByDate: LinearGraphGroupBy;
}

export type EventSalesStatsGroupByParams = {
  eventId?: string;
  params: EventSalesStatsGroupByQueryParams;
  options?: Record<string, boolean | number>;
};

export const createEventSalesStatsGroupbyKey = (
  eventId: string | undefined,
  params: EventSalesStatsGroupByQueryParams
) => {
  const queryParams = paramsSerializer({ ...params });
  return [QUERY_KEYS.eventSalesStatsGroupBy, eventId, queryParams];
};

const getCompanyEventStatsGroupby = async ({ eventId, params }: EventSalesStatsGroupByParams) => {
  const queryParams = paramsSerializer({ ...params });
  const url = `${import.meta.env.VITE_MONOLITH_HOST}/v1/nightgraph/events/${eventId}/sales-stats-grouped-by-date?${queryParams}`;
  return request({ url, method: RequestMethod.GET });
};

export const useGetEventSalesStatsGroupBy = ({ eventId, params, options }: EventSalesStatsGroupByParams) => {
  return useGenericQuery<EventSalesStatsGroupByResponse, RequestError>(
    createEventSalesStatsGroupbyKey(eventId, params),
    () => getCompanyEventStatsGroupby({ eventId, params }),
    {
      ...options,
    },
    true
  );
};
